import React from 'react';

interface Props {
  color?: string;
  width?: string;
  height?: string;
}
const ClosedGift: React.FC<Props> = ({
  color = '#DA604F',
  height = '94',
  width = '94',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 94 94"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectángulo_40842"
          data-name="Rectángulo 40842"
          width="71.446"
          height="79.17"
          fill={color}
        />
      </clipPath>
    </defs>
    <g
      id="Grupo_180145"
      data-name="Grupo 180145"
      transform="translate(-1020 -393)"
    >
      <rect
        id="Rectángulo_40843"
        data-name="Rectángulo 40843"
        width="94"
        height="94"
        transform="translate(1020 393)"
        fill="none"
      />
      <g
        id="Grupo_180143"
        data-name="Grupo 180143"
        transform="translate(1031 401)"
      >
        <path
          id="Trazado_520873"
          data-name="Trazado 520873"
          d="M17.88,35l.154.154V35Z"
          transform="translate(5.137 10.056)"
          fill={color}
        />
        <g id="Grupo_180144" data-name="Grupo 180144">
          <g
            id="Grupo_180143-2"
            data-name="Grupo 180143"
            clipPath="url(#clip-path)"
          >
            <path
              id="Trazado_520874"
              data-name="Trazado 520874"
              d="M63.709,20.6A12.618,12.618,0,0,0,67.262,11.8v-.863A10.966,10.966,0,0,0,56.32,0,22.365,22.365,0,0,0,40.4,6.591a22.1,22.1,0,0,0-4.673,6.81A22.524,22.524,0,0,0,15.126,0,10.958,10.958,0,0,0,4.184,10.942V11.8A12.618,12.618,0,0,0,7.737,20.6H0V45.056H2.575V79.17h66.3V45.056h2.575V20.6ZM43.125,9.32a18.538,18.538,0,0,1,13.2-5.458,7.093,7.093,0,0,1,7.08,7.08V11.8A8.8,8.8,0,0,1,54.608,20.6H37.744A18.538,18.538,0,0,1,43.125,9.32m.541,15.1.039.039.708.772.051.051,3.81,4.145L59.114,41.194l.026.026-4.364,3.836-6.5,5.716-3.862,3.386L40.963,57.2,27.3,43.833V24.459ZM8.046,10.942a7.084,7.084,0,0,1,7.08-7.08A18.65,18.65,0,0,1,33.689,20.6H16.838A8.8,8.8,0,0,1,8.046,11.8ZM3.862,24.459h19.31V41.194H3.862ZM65.01,75.308H48.275V62.036l-3.862,3.553v9.719H27.034V54.582L23.172,50.54V75.308H6.437V45.056H23.172v.154l3.862,3.862L40.757,62.808l3.656-3.257,3.862-3.437,7.737-6.9,4.66-4.158H65.01Zm2.575-34.114H64.559L48.944,24.459h18.64Z"
              fill={color}
            />
            <path
              id="Trazado_520875"
              data-name="Trazado 520875"
              d="M32.6,23.724a5.153,5.153,0,0,0-3.656-1.674,5.255,5.255,0,0,0-5.458,5.085,5.268,5.268,0,1,0,10.53.373c0-.193.013-.373,0-.554A5.215,5.215,0,0,0,32.6,23.724m-2.961,4.544a1.293,1.293,0,1,1-1.764-1.892,1.141,1.141,0,0,1,.8-.348l.129-.013a1.247,1.247,0,0,1,.9.425,1.173,1.173,0,0,1,.335.927,1.27,1.27,0,0,1-.4.9"
              transform="translate(6.745 6.335)"
              fill={color}
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default ClosedGift;
